/**
 * November 2017 - This enum was moved from odsp-shared-sharing.
 * Originally copied from DocumentSharingTypes.cs in SPOREL.
 */

export const enum SharingRoleV3 {
    none = 0,
    view = 1,
    edit = 2,
    owner = 3,
    review = 6,
    restrictedview = 7,
}
